/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import useApiRequest from '../../store/slices/hook/useApiRequest';
import Button from '../common/Button';
import Input from '../common/Input';
import { selectSkillsSlide, setSelectedSkills, toggleSkillsSlide } from '../../store/slices/common';
import SlideOver from '../SlideOver';
import { createSkill, updateSkill } from '../../store/slices/api/inner/skillsSlice';
import Select from '../common/Select';
import { fetchSkillType, setSkillTypeData } from '../../store/slices/api/inner/skillTypeSlice';

const SkillsForm = ({
    defaultData,
    fetchData,
}) => {
    const SkillIsOpen = useSelector(selectSkillsSlide);
    const dispatch = useDispatch();
    const [skillTypeOptions, setSkillTypeOptions] = useState([])

    const defaultValues = {
        skillTypeId: defaultData?.skill_type_id ?? "",
        name: defaultData?.name ?? "",
    }

    const afterAPICall = (response) => {
        fetchData();
        dispatch(toggleSkillsSlide())
        dispatch(setSelectedSkills(null))
    }

    const beforeAPICall = (data) => {
        return {
            success: true,
            refactoredData: {
                skillId: defaultData?.skill_id ?? "",
                skillTypeId: data.skillTypeId, 
                name: data.name
            }
        }
    }
    const { isLoading, control, handleSubmit, setValue } = useApiRequest({
        apiAction: defaultData ? updateSkill : createSkill,
        defaultValues,
        clearForm: true,
        beforeAPICall,
        afterAPICall,
    });

    useEffect(() => {
        if (defaultData) {
            setValue('skillId', defaultData.skill_id ?? "");
            setValue('name', defaultData.name ?? "");
            setValue('skillTypeId', defaultData.skill_type_id ?? "");
        } else {
            setValue('skillId', "");
            setValue('name', "");
            setValue('skillTypeId', "");
        }
    }, [defaultData, setValue]);

    // fetch start
    const afterFetch = (response) => {
        setSkillTypeOptions(response ? response?.map(skillType => ({ label: skillType?.skill_type_name, value: skillType?.skill_type_id })) : [])
    }
    const { handleSubmit: fetchSkillTypeData } = useApiRequest({
        apiAction: fetchSkillType,
        setValueAction: setSkillTypeData,
        isForm: false,
        successMessage: false,
        afterAPICall: afterFetch,
    });

    useEffect(() => {
        fetchSkillTypeData()
    }, [])
    // fetch end

    return (
        <SlideOver isOpen={SkillIsOpen} toggleOpen={toggleSkillsSlide} panelName= {defaultData ? "Update Skill" : "Add Skill"}>
            <form onSubmit={handleSubmit}>
                <Input
                    control={control}
                    name="name"
                    rules={{
                        required: "this field is required"
                    }}
                    label="Name"
                />
                <Select
                    control={control}
                    name="skillTypeId"
                    rules={{ required: "this field is required" }}
                    options={skillTypeOptions}
                />

                <div className="flex justify-end my-6">
                    <Button isLoading={isLoading}>
                        {defaultData ? "Save changes" : "Submit"}
                    </Button>
                </div>
            </form>
        </SlideOver>
    )
}

export default SkillsForm